"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_mock_adapter_1 = __importDefault(require("axios-mock-adapter"));
exports.default = (function (mockConfig) {
    return function (axios) {
        var mock = new axios_mock_adapter_1.default(axios, { delayResponse: 200 });
        mockConfig(mock);
        axios.interceptors.request.use(function (config) {
            if (config.baseURL && config.url && config.url.startsWith(config.baseURL)) {
                config.url = config.url.slice(config.baseURL.length);
            }
            return config;
        });
        mock.onAny().passThrough();
    };
});
